import React, { Component } from 'react';

import Rating from './Rating';



import * as endpoints from './../../../Service/endpoints';
class SingleProduct extends Component {

    state = {
        path: ''
    }
    style = {
        borderStyle: {
            border: "1px solid hsla(240,2%,88%,.74)",
            borderRadius: '8px'
        },
        productBorder: {
            display: 'inline-block',
            position: 'relative',
            top: '-5px'
        }
    }

    getProductUrl = (product) => {

        if (typeof product.category != "undefined") {
            return endpoints.getRoute(`${product.category.slug}/${product.subCategory.slug}/${product.slug}`);
        } else {
            return "#";
        }

    }

    
    render() {
        console.log("products", this.props.product);
        const currentCity = endpoints.getCurrentCity();

        return (
            <div className={'col-12 col-md-4 mb-3 col-' + (this.props.length == 4 ? 'xl-3' : 'lg-4') + this.props.styleValue.padding}>
  <div style={this.style.borderStyle}>

    {/* 🚚 Instant Delivery Banner */}
    { this.props.product.instantDelivery && currentCity === "gurgaon" && (
      <div style={{
        background : "#004a80",
        color: 'white',
        fontWeight: '600',
        fontSize: '14px',
        textAlign: 'center',
        padding: '10px 0',
        borderTopLeftRadius: '10px',
        borderTopRightRadius: '10px',
        fontFamily: 'Arial, sans-serif',
        boxShadow: '0 2px 6px rgba(0,0,0,0.15)'
      }}>

         Express Delivery Available  {"  "} 
        <img src="/svg/ExpressDelivery.svg" alt="Express Delivery" style={{ width: 18, height: 18, marginRight: 8 }} />
      </div>
    )}

    {/* Image Section */}
    <div className="row m-0 ph-item">
      <div className="col-12 p-0 position-relative">
        <img
          style={{ width: '100%', maxHeight: '220px', borderRadius: '0 0 10px 10px' }}
          src={this.props.product.featuredImage}
          alt={this.props.product.slug}
        />
        {this.props.product.status === 'Out of Stock' && (
          <span style={{
            position: 'absolute',
            background: 'white',
            right: '-10px',
            color: 'red',
            transform: 'rotate(40deg)',
            top: '20px',
            fontWeight: 'bold',
            padding: '2px 6px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
          }}>
            Out Of Stock
          </span>
        )}
      </div>
    </div>

    {/* Product Info Section */}
    <div className="row m-1">
      <div className="col-12 pb-3">
        <a href={this.getProductUrl(this.props.product)} type="button">
          <span className="font-weight-bold">{this.props.product.name}</span>
        </a>

        <div className="mt-1">
          {this.props.isMedical !== true && this.props.product.category.slug !== 'seasonal' && (
            <div>
              <span className="text-black-50">Starting from :</span>
              <span> ₹ {parseFloat(this.props.product.startingFrom / 1.18).toFixed(0)}/month</span>
            </div>
          )}

          {this.props.isMedical !== true && this.props.product.category.slug === 'seasonal' && (
            <div>
              <span className="text-black-50">Starting from :</span>
              <span> ₹ {parseFloat(this.props.product.startingFrom / 1.18).toFixed(0)}/season</span>
            </div>
          )}

          {this.props.product.category.slug !== 'premium' && this.props.product.category.slug !== 'seasonal' && (
            <span className="d-block">
              <span className="text-black-50">Min. Tenure :</span>
              <span className="ml-2">{this.props.minTenure}</span>
            </span>
          )}

          
        </div>

        <div className="text-right">
          <a href={this.getProductUrl(this.props.product)} type="button" className="btn btn-sm btn-outline-primary mt-2">
            View Product
          </a>
        </div>
      </div>
    </div>

  </div>
</div>

   ) } 
}

export default SingleProduct;
